module.exports = __webpack_public_path__ + "img/ic24Bus.34f235af.svg";